<template>
  <div class="tabmenudemo-content">
    <div v-if="!patient">
      <p>Please select a patient</p>
    </div>
    <div v-for="(patient) in previousSessionsData" :key="patient.mrn" class="container-div">
      <div>
        <span class="date-span">{{ patient.date }}</span>
      </div>
      <div>
        <span class="tumor-board-span">{{ `${patient.tb_name} Tumor Board Meeting` }}</span>
      </div>
      <div>
        <span class="notes-span">{{ patient.recording_info.notes }}</span>
      </div>
    </div>
  </div>
</template>

<script setup>
// Copyright (c) 2020-2023 Omics Data Automation, Inc.
// Copyright (c) 2023 datma, inc.
//
// Proprietary and Confidential:
// Unauthorized copying of this file by any medium is strictly prohibited.

import { ref, watch, computed } from 'vue'
import { useStore } from 'vuex'
import { getTumorBoardSessionsData } from './getTumorBoardSessionsData'

const store = useStore()
const previousSessionsData = ref([])
const patient = computed(() => store.getters.session.patient)

watch(patient, async (newPatient) => {
  if (!newPatient) return {}
  const tumorBoardSessionsData = await getTumorBoardSessionsData(patient.value.id)
  store.dispatch('setTumorBoardSessionsData', { tumorBoardSessionsData, publish: true })
  const previousSessions = tumorBoardSessionsData.Past
  previousSessionsData.value = previousSessions.map(item => ({ ...item, mrn: patient.value.id }))
})

</script>

<style scoped>
.tabmenudemo-content {
  text-align: initial;
}

.date-span {
  font-size: 12px;
  font-weight: 500;
  line-height: 18px;
  color: var(--Grey500);
}

.tumor-board-span {
  font-size: 14px;
  font-weight: 400;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey800);
}

.notes-span {
  font-size: 14px;
  font-weight: 300;
  line-height: 16.41px;
  letter-spacing: -0.32px;
  color: var(--Grey900);
}

.container-div {
  margin-bottom: 10%;
}
</style>
